import React from 'react';

const PnLProfit = () => {
    return (
        <svg
            width="343"
            height="429"
            viewBox="0 0 343 429"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_44758_4212)">
                <rect width="343" height="359" fill="#050505" />
                <g style={{ mixBlendMode: 'color-dodge' }}>
                    <path
                        d="M-179.487 18.3046C-183.381 32.0745 -180.67 47.0498 -172.358 62.3704C-164.043 77.6938 -150.138 93.3318 -131.708 108.385C-94.8496 138.492 -39.9671 166.199 24.2046 184.345C88.3762 202.491 149.641 207.627 196.808 201.281C220.392 198.108 240.426 192.067 255.534 183.367C270.639 174.668 280.79 163.33 284.684 149.56C288.578 135.79 285.868 120.815 277.555 105.494C269.24 90.1708 255.335 74.5329 236.905 59.4792C200.047 29.3729 145.164 1.66618 80.9925 -16.4799C16.8208 -34.626 -44.4439 -39.7626 -91.6105 -33.4165C-115.195 -30.2433 -135.229 -24.2026 -150.337 -15.5023C-165.442 -6.8037 -175.593 4.53479 -179.487 18.3046Z"
                        stroke="url(#paint0_linear_44758_4212)"
                        strokeOpacity="0.15"
                    />
                    <path
                        d="M-284.824 -11.4807C-290.502 8.59867 -286.544 30.4184 -274.447 52.7135C-262.348 75.0114 -242.122 97.7539 -215.33 119.638C-161.748 163.404 -81.9775 203.672 11.2821 230.043C104.542 256.415 193.587 263.883 262.154 254.658C296.439 250.045 325.579 241.262 347.563 228.601C369.544 215.943 384.342 199.427 390.02 179.348C395.698 159.268 391.74 137.449 379.643 115.153C367.544 92.8556 347.319 70.113 320.527 48.2293C266.944 4.46312 187.174 -35.8051 93.9143 -62.1765C0.654684 -88.5479 -88.3905 -96.0162 -156.958 -86.7908C-191.242 -82.1779 -220.382 -73.3947 -242.366 -60.7345C-264.348 -48.076 -279.146 -31.5601 -284.824 -11.4807Z"
                        stroke="url(#paint1_linear_44758_4212)"
                        strokeOpacity="0.15"
                    />
                    <path
                        d="M-412.999 -47.7246C-420.848 -19.9676 -415.372 10.1804 -398.67 40.9621C-381.966 71.7467 -354.049 103.134 -317.082 133.329C-243.15 193.716 -133.096 249.27 -4.44186 285.65C124.212 322.03 247.061 332.335 341.669 319.606C388.974 313.242 429.193 301.121 459.545 283.643C489.893 266.166 510.346 243.35 518.195 215.593C526.044 187.836 520.568 157.688 503.866 126.906C487.162 96.1217 459.245 64.7342 422.278 34.5397C348.346 -25.8481 238.292 -81.4014 109.638 -117.781C-19.0162 -154.161 -141.865 -164.467 -236.473 -151.738C-283.778 -145.373 -323.997 -133.253 -354.349 -115.774C-384.697 -98.2973 -405.15 -75.4815 -412.999 -47.7246Z"
                        stroke="url(#paint2_linear_44758_4212)"
                        strokeOpacity="0.15"
                    />
                </g>
                <path
                    d="M232.094 179.179L232.01 179.222L253.316 188.244L253.355 188.184L232.094 179.179Z"
                    fill="url(#paint3_linear_44758_4212)"
                    stroke="#231F20"
                    strokeMiterlimit="10"
                />
                <path
                    d="M314.997 130.212L309.722 213.974L291.616 205.233L225.402 309.552L128.332 323.278L36.6363 500.593L-62.2651 515.38L-168.218 657.982L-206.686 640.611L-206.651 640.567L-100.579 497.573L-1.70091 482.197L88.499 305.553L186.621 292.579L254.156 188.603L253.316 188.244L253.356 188.184L232.095 179.179L232.011 179.222L314.137 130.72L314.997 130.212Z"
                    fill="url(#paint4_linear_44758_4212)"
                />
                <path
                    d="M314.997 130.212L315.748 143.248L310.92 218.207L291.941 209.383L226.247 312.267L130.077 326.568L37.4235 503.72L-61.4974 518.261L-163.673 655.948L-168.218 657.982L-62.2652 515.38L36.6362 500.593L128.332 323.278L225.402 309.552L291.616 205.233L309.722 213.974L314.997 130.212Z"
                    fill="url(#paint5_linear_44758_4212)"
                    fillOpacity="0.5"
                />
                <g style={{ mixBlendMode: 'screen' }}>
                    <path
                        d="M253.355 188.184L253.316 188.244L232.01 179.222L232.094 179.179L253.355 188.184Z"
                        fill="url(#paint6_radial_44758_4212)"
                        stroke="#231F20"
                        strokeMiterlimit="10"
                    />
                </g>
                <g clipPath="url(#clip1_44758_4212)">
                    <path
                        d="M41.8381 27.8405C40.9124 28.7607 39.782 29.2203 38.447 29.2203C37.1119 29.2203 35.9849 28.7607 35.0647 27.8405C34.1445 26.9203 33.685 25.7933 33.685 24.4583C33.685 23.1233 34.1445 21.9962 35.0647 21.076C35.9849 20.1558 37.1119 19.6963 38.447 19.6963C39.782 19.6963 40.9112 20.1558 41.8381 21.076C42.7639 21.9962 43.2268 23.1233 43.2268 24.4583C43.2268 25.7933 42.7639 26.9203 41.8381 27.8405ZM36.7072 26.2439C37.1701 26.7124 37.7504 26.9472 38.4481 26.9472C39.1458 26.9472 39.7283 26.7124 40.1979 26.2439C40.6664 25.7754 40.9012 25.1794 40.9012 24.4583C40.9012 23.7371 40.6664 23.1412 40.1979 22.6727C39.7294 22.2042 39.1458 21.9694 38.4481 21.9694C37.7504 21.9694 37.1701 22.2042 36.7072 22.6727C36.2443 23.1412 36.0129 23.7371 36.0129 24.4583C36.0129 25.1794 36.2443 25.7754 36.7072 26.2439Z"
                        fill="#DFF60D"
                    />
                    <path
                        d="M46.0221 18.8678C45.6375 18.8678 45.3031 18.7269 45.0214 18.444C44.7385 18.1623 44.5976 17.828 44.5976 17.4433C44.5976 17.0587 44.7385 16.7222 45.0214 16.4337C45.3043 16.1452 45.6375 16.001 46.0221 16.001C46.4067 16.001 46.7578 16.1452 47.0407 16.4337C47.3224 16.7222 47.4644 17.0587 47.4644 17.4433C47.4644 17.828 47.3236 18.1623 47.0407 18.444C46.7578 18.7269 46.4179 18.8678 46.0221 18.8678ZM44.8682 28.9676V19.9501H47.195V28.9676H44.8682Z"
                        fill="#DFF60D"
                    />
                    <path
                        d="M54.3374 19.6973C55.3235 19.6973 56.1375 20.0282 56.7815 20.689C57.4244 21.3509 57.7465 22.2644 57.7465 23.4306V28.9674H55.4197V23.7191C55.4197 23.1175 55.2576 22.658 54.9333 22.3393C54.608 22.0207 54.1753 21.8619 53.6352 21.8619C53.0337 21.8619 52.5529 22.0486 52.1917 22.421C51.8317 22.7944 51.6506 23.3535 51.6506 24.0981V28.9674H49.3238V19.95H51.6506V20.9596C52.2152 20.1177 53.1119 19.6973 54.3374 19.6973Z"
                        fill="#DFF60D"
                    />
                    <path
                        d="M64.5814 16.0908C65.363 16.0908 66.3849 16.2172 67.6472 16.4699V28.9691H65.3205V18.147C65.1516 18.1347 64.9057 18.1291 64.5814 18.1291C63.3068 18.1291 62.6695 18.7061 62.6695 19.8611V19.9516H64.1666V22.1878H62.6695V28.9691H60.3427V22.1878H59.0446V19.9516H60.3427V19.8611C60.3427 17.3487 61.756 16.0919 64.5814 16.0919V16.0908Z"
                        fill="#DFF60D"
                    />
                    <path
                        d="M76.6301 19.9501H78.9568V28.9676H76.6301V27.9031C75.9324 28.7808 74.9529 29.2203 73.6906 29.2203C72.4282 29.2203 71.4566 28.7607 70.5979 27.8405C69.7381 26.9203 69.3076 25.7933 69.3076 24.4583C69.3076 23.1233 69.737 21.9962 70.5979 21.076C71.4577 20.1558 72.4886 19.6963 73.6906 19.6963C74.9529 19.6963 75.9335 20.1357 76.6301 21.0134V19.949V19.9501ZM72.3377 26.2897C72.8062 26.7649 73.4021 27.0019 74.1233 27.0019C74.8444 27.0019 75.4426 26.7649 75.9178 26.2897C76.393 25.8145 76.6301 25.2052 76.6301 24.4594C76.6301 23.7136 76.3919 23.1043 75.9178 22.6291C75.4426 22.1539 74.8444 21.9168 74.1233 21.9168C73.4021 21.9168 72.8062 22.155 72.3377 22.6291C71.8692 23.1043 71.6344 23.7147 71.6344 24.4594C71.6344 25.204 71.8692 25.8156 72.3377 26.2897Z"
                        fill="#DFF60D"
                    />
                    <path
                        d="M83.3923 21.5013C83.6092 20.9244 83.9659 20.4917 84.4657 20.2032C84.9644 19.9147 85.5212 19.7705 86.1339 19.7705V22.3679C85.4239 22.284 84.7899 22.4282 84.2309 22.8006C83.6718 23.1729 83.3923 23.7923 83.3923 24.6577V28.968H81.0656V19.9505H83.3923V21.5013Z"
                        fill="#DFF60D"
                    />
                    <path
                        d="M89.1103 25.4144C89.4234 26.5448 90.2709 27.1094 91.6528 27.1094C92.5428 27.1094 93.2159 26.8087 93.6732 26.2071L95.5494 27.2894C94.6594 28.5764 93.349 29.2193 91.6182 29.2193C90.1266 29.2193 88.9303 28.7687 88.0291 27.8664C87.1268 26.9641 86.6762 25.8281 86.6762 24.4573C86.6762 23.0865 87.1212 21.9651 88.0112 21.0572C88.9012 20.1493 90.0428 19.6953 91.4382 19.6953C92.7609 19.6953 93.8521 20.1526 94.712 21.0661C95.5718 21.9796 96.0011 23.11 96.0011 24.4573C96.0011 24.7581 95.9709 25.0767 95.9106 25.4133H89.1103V25.4144ZM89.0745 23.6109H93.6732C93.5413 22.9982 93.2674 22.5409 92.8526 22.2401C92.4377 21.9393 91.9659 21.7895 91.437 21.7895C90.812 21.7895 90.2943 21.9494 89.8862 22.2669C89.477 22.5856 89.2064 23.034 89.0745 23.6109Z"
                        fill="#DFF60D"
                    />
                    <path
                        d="M23.4555 19.6822C23.5885 20.3151 23.8133 20.7824 24.1409 21.11C24.1867 21.1559 24.237 21.1995 24.2885 21.242C24.4718 20.6706 24.7704 20.1686 25.1885 19.7404C25.9321 18.9789 26.9104 18.5977 28.1247 18.5977C28.838 18.5977 29.4809 18.7553 30.0523 19.0706C30.6236 19.3859 31.0641 19.8231 31.3727 20.3822L33.4971 19.1511C32.9616 18.2466 32.2147 17.5299 31.2576 16.9999C30.2994 16.471 29.2551 16.2061 28.1247 16.2061C26.244 16.2061 24.6921 16.8277 23.4667 18.071C23.4108 18.1269 23.3582 18.184 23.3045 18.2421C23.3079 18.3774 23.3146 18.5093 23.3224 18.6346C23.347 19.0259 23.3917 19.3781 23.4555 19.6811V19.6822Z"
                        fill="#DFF60D"
                    />
                    <path
                        d="M30.0623 26.3175C29.4854 26.6328 28.8403 26.7904 28.1258 26.7904C26.9127 26.7904 25.9332 26.4103 25.1897 25.6478C24.7782 25.2262 24.483 24.7354 24.2985 24.1797C24.2438 24.2244 24.1901 24.2703 24.1409 24.3194C23.8133 24.6471 23.5897 25.1122 23.4566 25.7428C23.394 26.038 23.3493 26.3823 23.3247 26.7647C23.3168 26.8911 23.3101 27.0208 23.3057 27.1561C23.3582 27.2131 23.4108 27.2701 23.4667 27.326C24.6921 28.5749 26.2451 29.2 28.1247 29.2C29.2674 29.2 30.3139 28.935 31.2665 28.4061C32.218 27.8772 32.9616 27.1594 33.4971 26.2549L31.3728 25.0239C31.0753 25.5717 30.6382 26.0022 30.0612 26.3175H30.0623Z"
                        fill="#DFF60D"
                    />
                    <path
                        d="M26.8612 22.5078C25.2277 22.5078 24.2303 22.0538 23.6277 21.4523C23.025 20.8508 22.7567 19.8523 22.7567 18.2188H22.4089V27.1501H22.7567C22.7567 24.0038 23.716 22.86 26.8612 22.86L28.8224 22.7672V22.5995L26.8612 22.5067V22.5078Z"
                        fill="#DFF60D"
                    />
                    <path
                        d="M17.9611 22.5078C19.5947 22.5078 20.592 22.0538 21.1947 21.4523C21.7973 20.8508 22.0657 19.8523 22.0657 18.2188H22.4134V27.1501H22.0657C22.0657 24.0038 21.1064 22.86 17.9611 22.86L16 22.7672V22.5995L17.9611 22.5067V22.5078Z"
                        fill="#DFF60D"
                    />
                </g>
            </g>
            <rect width="343" height="70" transform="translate(0 359)" fill="#F6F6F6" />
            <defs>
                <linearGradient
                    id="paint0_linear_44758_4212"
                    x1="274.973"
                    y1="134.529"
                    x2="-160.41"
                    y2="77.4552"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#DFF60D" />
                    <stop offset="0.491388" stopColor="white" />
                    <stop offset="1" stopColor="#DFF60D" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_44758_4212"
                    x1="375.693"
                    y1="157.446"
                    x2="-256.889"
                    y2="74.5226"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#DFF60D" />
                    <stop offset="0.491388" stopColor="white" />
                    <stop offset="1" stopColor="#DFF60D" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_44758_4212"
                    x1="498.25"
                    y1="185.332"
                    x2="-374.285"
                    y2="70.9536"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#DFF60D" />
                    <stop offset="0.491388" stopColor="white" />
                    <stop offset="1" stopColor="#DFF60D" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_44758_4212"
                    x1="240.766"
                    y1="185.908"
                    x2="244.283"
                    y2="181.39"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#AE3DBB" />
                    <stop offset="0.08" stopColor="#9E3DC0" />
                    <stop offset="0.27" stopColor="#7C3DCC" />
                    <stop offset="0.38" stopColor="#703ED1" />
                    <stop offset="0.59" stopColor="#5A77DF" />
                    <stop offset="0.72" stopColor="#4C9DE9" />
                    <stop offset="1" stopColor="#43E8E1" />
                </linearGradient>
                <linearGradient
                    id="paint4_linear_44758_4212"
                    x1="277.78"
                    y1="180.974"
                    x2="152.321"
                    y2="434.302"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#2FBE64" />
                    <stop offset="0.684069" stopColor="#DFF60D" />
                    <stop offset="1" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint5_linear_44758_4212"
                    x1="331.132"
                    y1="154.996"
                    x2="182.888"
                    y2="453.239"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#2FBE64" />
                    <stop offset="0.726066" stopColor="#DFF60D" />
                    <stop offset="1" stopOpacity="0" />
                </linearGradient>
                <radialGradient
                    id="paint6_radial_44758_4212"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(242.683 183.713) rotate(-4.99411) scale(8.40372 7.95599)"
                >
                    <stop stopColor="#836DF3" />
                    <stop offset="0.11" stopColor="#6554BC" />
                    <stop offset="0.23" stopColor="#4A3E8B" />
                    <stop offset="0.36" stopColor="#332B60" />
                    <stop offset="0.48" stopColor="#211B3D" />
                    <stop offset="0.61" stopColor="#120F22" />
                    <stop offset="0.73" stopColor="#08060F" />
                    <stop offset="0.86" stopColor="#020103" />
                    <stop offset="1" />
                </radialGradient>
                <clipPath id="clip0_44758_4212">
                    <rect width="343" height="359" fill="white" />
                </clipPath>
                <clipPath id="clip1_44758_4212">
                    <rect width="80" height="13.2204" fill="white" transform="translate(16 16)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default PnLProfit;
